/**
 * web/src/pages/Login.tsx -- email/password signin + signup toggle.
 */
import { Component, createSignal, Show } from "solid-js";
import { A, useNavigate, useSearchParams } from "@solidjs/router";
import { signInEmail } from "../auth";

const Login: Component = () => {
  const [email, setEmail] = createSignal("");
  const [password, setPassword] = createSignal("");
  const [params] = useSearchParams();
  const [mode, setMode] = createSignal<"signin" | "signup">(params.mode === "signup" ? "signup" : "signin");
  const [busy, setBusy] = createSignal(false);
  const [err, setErr] = createSignal<string | null>(null);
  const navigate = useNavigate();

  const submit = async (e: Event) => {
    e.preventDefault();
    setBusy(true); setErr(null);
    try {
      await signInEmail(email(), password(), mode());
      navigate(params.next === "pricing" ? "/pricing" : params.next === "success" ? "/success" : "/app");
    } catch (e) {
      setErr((e as Error).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div class="auth-layout">
      <div class="auth-copy"><div class="page-eyebrow">WELCOME TO THE EDGE</div><h1>{mode() === "signin" ? "Good to see you again." : "Start with a free account."}</h1><p>Track the market, inspect the data and upgrade only when you are ready for the complete model.</p></div>
      <div class="auth-card">
      <h2>{mode() === "signin" ? "Log in" : "Create your account"}</h2>
      <form onSubmit={submit}>
        <label>
          <div>Email</div>
          <input type="email" required value={email()}
            onInput={(e) => setEmail(e.currentTarget.value)}
            placeholder="you@example.com" />
        </label>
        <label>
          <div>Password</div>
          <input type="password" required minlength="8" value={password()}
            onInput={(e) => setPassword(e.currentTarget.value)}
            placeholder="8 characters minimum" />
        </label>
        <Show when={mode() === "signup"}>
          <label class="terms-check">
            <input type="checkbox" required />
            <span>I am at least 18 and agree to the <A href="/terms">Terms of Use</A> and acknowledge the <A href="/privacy">Privacy Policy</A>.</span>
          </label>
        </Show>
        <button class="button button-primary button-wide" type="submit" disabled={busy()}>{busy() ? "Please wait…" : mode() === "signin" ? "Log in" : "Create free account"}</button>
      </form>
      <Show when={err()}>
        <p class="form-error">{err()}</p>
      </Show>
      <p class="auth-switch">
        <Show when={mode() === "signin"} fallback={
          <>Already have an account? <a href="#" onClick={(e) => { e.preventDefault(); setMode("signin"); }}>Sign in</a></>
        }>
          No account yet? <a href="#" onClick={(e) => { e.preventDefault(); setMode("signup"); }}>Create one</a>
        </Show>
      </p>
      <p class="auth-fine">Rating Races Pro provides statistical information only—not betting advice, gambling advice or sports picks.</p>
      </div>
    </div>
  );
};

export default Login;
